//TODO export from DS
export enum ButtonSignInVariant {
  Google = 'Google',
  Facebook = 'Facebook',
  Apple = 'Apple',
  Twitter = 'Twitter',
  Windows = 'Windows',
}
